// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'abb5d9a5-b8b7-4985-9fb2-ee30bfd36908',
      type: 'Sprite',
      name: 'slideShadow',
      className: '',
      x: 218,
      y: -415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '34078787-e7bf-45ec-9bf7-f37b0539a4df',
      type: 'Sprite',
      name: 'slide',
      className: '',
      x: 169,
      y: -386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Slide',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 7,
        labelOffset: {
          x: 49,
          y: -19
        }
      }
    },
    {
      id: 'a96d0ea0-d3ed-422b-a328-b467ef57fadb',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'AQUA LAND',
        reward: {
          'Coin': 100,
          'BoosterMove': 1,
        }
      }
    },
    {
      id: '1e647f73-e5a0-4578-bfc7-37453b0b35fe',
      type: 'Sprite',
      name: 'shellShadow',
      className: '',
      x: 176,
      y: -197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Shell_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 1
      }
    },
    {
      id: 'b88609f2-b5ec-4f49-9a1d-45b654cdbf63',
      type: 'Sprite',
      name: 'shell',
      className: '',
      x: 188,
      y: -208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Shell',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 1
      }
    },
    {
      id: 'dc3fb129-fecc-446a-8a61-eff5a34cad3a',
      type: 'Sprite',
      name: 'houseShadow',
      className: '',
      x: 11,
      y: -300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1200,
        order: 2
      }
    },
    {
      id: 'a43ed8b5-6ba3-439b-916b-f0e89158c8fb',
      type: 'Sprite',
      name: 'house',
      className: '',
      x: 37,
      y: -323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_House',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1200,
        order: 2
      }
    },
    {
      id: 'd25d413c-0b8e-44ce-9a4b-ef82bcfa6bcd',
      type: 'Sprite',
      name: 'crabShadow',
      className: '',
      x: -55,
      y: -460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Crab_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 3
      }
    },
    {
      id: 'b9abccb0-864b-4890-9ba6-07700b2184dd',
      type: 'Sprite',
      name: 'crab',
      className: '',
      x: -61,
      y: -501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Crab',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 3
      }
    },
    {
      id: 'ec4ee556-73a1-47ac-9323-279201d7286e',
      type: 'Sprite',
      name: 'submarineShadow',
      className: '',
      x: -207,
      y: -394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Submarine_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 4
      }
    },
    {
      id: '1406e3ba-ec3f-47ae-8e89-f36947e624b0',
      type: 'Sprite',
      name: 'submarine',
      className: '',
      x: -213,
      y: -476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Submarine',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 4
      }
    },
    {
      id: 'dbdfcc9e-a1bb-4da7-b780-6217c2b19243',
      type: 'Sprite',
      name: 'octopusShadow',
      className: '',
      x: 47,
      y: -115,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Octopus_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1200,
        order: 5
      }
    },
    {
      id: 'af99d39f-06cb-46f6-b9bd-416105cb64db',
      type: 'Sprite',
      name: 'octopus',
      className: '',
      x: 61,
      y: -136,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Octopus',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1200,
        order: 5
      }
    },
    {
      id: 'a3a29f97-10a7-463a-98e9-b471ca0732db',
      type: 'Sprite',
      name: 'shipShadow',
      className: '',
      x: -147,
      y: -195,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Pirate_Ship_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 6
      }
    },
    {
      id: 'cf8a2991-4550-41c1-a616-0df307c1a39b',
      type: 'Sprite',
      name: 'ship',
      className: '',
      x: -112,
      y: -295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_7_Pirate_Ship',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 6
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_7 {
  static raw = raw;
  root!: Container;
  slideShadow!: Sprite;
  slide!: Sprite & { data: typeof raw['list'][2]['data'] };
  island!: Sprite & { data: typeof raw['list'][3]['data'] };
  shellShadow!: Sprite & { data: typeof raw['list'][4]['data'] };
  shell!: Sprite & { data: typeof raw['list'][5]['data'] };
  houseShadow!: Sprite & { data: typeof raw['list'][6]['data'] };
  house!: Sprite & { data: typeof raw['list'][7]['data'] };
  crabShadow!: Sprite & { data: typeof raw['list'][8]['data'] };
  crab!: Sprite & { data: typeof raw['list'][9]['data'] };
  submarineShadow!: Sprite & { data: typeof raw['list'][10]['data'] };
  submarine!: Sprite & { data: typeof raw['list'][11]['data'] };
  octopusShadow!: Sprite & { data: typeof raw['list'][12]['data'] };
  octopus!: Sprite & { data: typeof raw['list'][13]['data'] };
  shipShadow!: Sprite & { data: typeof raw['list'][14]['data'] };
  ship!: Sprite & { data: typeof raw['list'][15]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
